import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-themeV2 disabled:cursor-not-allowed disabled:opacity-50  data-[state=checked]:border-themeV2  data-[state=checked]:bg-themeV2 data-[state=checked]:text-white !outline-none",
      className
    )}
    defaultValue={true}
    defaultChecked={true}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className="h-2.5 w-2.5" strokeWidth={"3"} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
